/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ca-central-1",
    "aws_appsync_graphqlEndpoint": "https://projt2juoza3pknntwq44iqmpy.appsync-api.ca-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "ca-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-ijuxtykz5naihiupdgs5r5p6ve",
    "aws_cognito_identity_pool_id": "ca-central-1:7d9e04b7-7156-4659-9299-db62ad8b44f4",
    "aws_cognito_region": "ca-central-1",
    "aws_user_pools_id": "ca-central-1_RR3KgWcI2",
    "aws_user_pools_web_client_id": "4497d0bficvjie4id6ct2dr7hf",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
